import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import Icon from '../components/AppIcon';

const Auth = () => {
  // 1. NOUVEAU : On ajoute des variables pour le Prénom et le Nom
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  const location = useLocation();
  const [isLoginMode, setIsLoginMode] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === '/register') {
      setIsLoginMode(false);
    }
  }, [location]);

  const handleAuth = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      if (isLoginMode) {
        // --- CONNEXION (Rien ne change ici) ---
        const { error } = await supabase.auth.signInWithPassword({
          email,
          password,
        });
        if (error) throw error;
        navigate('/student-profile');
      } else {
        // --- INSCRIPTION (C'est ici qu'on change tout !) ---
        const { error } = await supabase.auth.signUp({
          email,
          password,
          options: {
            data: {
              // 3. ENVOI : On envoie les vrais noms au lieu du truc par défaut
              // Supabase va les passer au Trigger SQL qu'on a créé
              first_name: firstName,
              last_name: lastName,
            },
          },
        });
        if (error) throw error;
        alert('Compte créé avec succès ! Bienvenue ' + firstName);
        navigate('/student-profile');
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/20 px-4 py-12">
      <div className="w-full max-w-md space-y-8 bg-card p-8 rounded-xl shadow-soft border border-border">
        
        {/* En-tête */}
        <div className="text-center">
          <Link to="/" className="inline-flex items-center justify-center w-12 h-12 rounded-lg bg-primary/10 mb-4">
            <Icon name="Compass" size={24} className="text-primary" />
          </Link>
          <h2 className="text-3xl font-heading font-bold text-foreground">
            {isLoginMode ? 'Bon retour parmi nous' : 'Créer un compte'}
          </h2>
          <p className="mt-2 text-sm text-muted-foreground">
            {isLoginMode 
              ? 'Connectez-vous pour accéder à votre espace' 
              : 'Rejoignez Afaqi pour gérer votre orientation'}
          </p>
        </div>

        {/* Formulaire */}
        <form className="mt-8 space-y-6" onSubmit={handleAuth}>
          {error && (
            <div className="p-3 text-sm text-red-500 bg-red-50 rounded-lg border border-red-100">
              {error}
            </div>
          )}
          
          <div className="space-y-4">
            
            {/* 2. AFFICHAGE : Ces champs n'apparaissent QUE si on s'inscrit (!isLoginMode) */}
            {!isLoginMode && (
              <div className="grid grid-cols-2 gap-4 animate-fade-in">
                <div>
                  <label htmlFor="firstName" className="block text-sm font-medium text-foreground">Prénom</label>
                  <input
                    id="firstName"
                    type="text"
                    required
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    className="mt-1 block w-full px-3 py-2 bg-background border border-border rounded-lg focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-smooth"
                    placeholder="Amine"
                  />
                </div>
                <div>
                  <label htmlFor="lastName" className="block text-sm font-medium text-foreground">Nom</label>
                  <input
                    id="lastName"
                    type="text"
                    required
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    className="mt-1 block w-full px-3 py-2 bg-background border border-border rounded-lg focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-smooth"
                    placeholder="Benali"
                  />
                </div>
              </div>
            )}

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-foreground">Email</label>
              <input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 block w-full px-3 py-2 bg-background border border-border rounded-lg focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-smooth"
                placeholder="exemple@email.com"
              />
            </div>
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-foreground">Mot de passe</label>
              <input
                id="password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 block w-full px-3 py-2 bg-background border border-border rounded-lg focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-smooth"
                placeholder="••••••••"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-smooth disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Chargement...' : (isLoginMode ? 'Se connecter' : "S'inscrire")}
          </button>
        </form>

        {/* Bascule Login / Register */}
        <div className="text-center mt-4">
          <button
            onClick={() => setIsLoginMode(!isLoginMode)}
            className="text-sm font-medium text-primary hover:text-primary/80 transition-smooth"
          >
            {isLoginMode 
              ? "Pas encore de compte ? S'inscrire" 
              : "Déjà un compte ? Se connecter"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Auth;